import { render } from "./edit.vue?vue&type=template&id=5ff52b28"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=5ff52b28&lang=css"

import exportComponent from "/Users/tommygrimm/PhpstormProjects/hauptportal.20north.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__